import { Col, Form, Row } from 'antd';
import { AInput } from '../Input';
import { ASelect } from '../Select';
import { ATextArea } from '../TextArea';
import { AButton } from '../Button';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { ATitle } from '../Title';
import { ACheckBoxGroup } from '../CheckBoxGroup';
import { useCallback } from 'react';
import { ICheckBox, IInput, IInputOption } from '../../shared/interfaces';

interface IPreviewFormProps {
  setInput?: React.Dispatch<React.SetStateAction<IInput | null | undefined>>;
  setModalCreate?: React.Dispatch<React.SetStateAction<boolean>>;
  inputs: IInput[];
  setInputs: React.Dispatch<React.SetStateAction<IInput[]>>;
  hideButtonEdit?: boolean;
  formData?: any | null;
  setFormData?: React.Dispatch<React.SetStateAction<any>>;
}

export const PreviewForm: React.FC<IPreviewFormProps> = ({
  setInput,
  setModalCreate,
  inputs,
  setInputs,
  hideButtonEdit,
  formData,
  setFormData,
}) => {
  const deleteInput = useCallback((index: number) => {
    inputs.splice(index, 1);
    setInputs([...inputs]);
  }, []);

  const editInput = useCallback((item: IInput) => {
    if (item && setInput && setModalCreate) {
      setInput(item);
      setModalCreate(true);
    }
  }, []);

  const getKeyField = (label: string) => {
    return label?.replace(/[?]/g, '').replace(/\s/g, '_').toLowerCase();
  };

  const handlerFormData = (
    key: string,
    value: string | number | ICheckBox[] | any,
  ) => {
    if (setFormData) {
      setFormData({
        ...formData,
        [key]: value,
      });
    }
  };

  const renderInput = (type: string, item: any) => {
    switch (type) {
      case 'select':
        return (
          <ASelect
            placeholder={item.label}
            value={hideButtonEdit ? formData[item.id] : ''}
            onChange={(e) => (hideButtonEdit ? handlerFormData(item.id, e) : e)}
            allowClear
            options={item.options
              .filter((x: IInputOption) => x.status)
              .map((opt: IInputOption) => ({
                label: opt.label,
                value: opt.value,
              }))}
          />
        );
      case 'checkbox':
        return (
          <ACheckBoxGroup
            value={hideButtonEdit ? formData[item.id] || [] : []}
            onChange={(e) => (hideButtonEdit ? handlerFormData(item.id, e) : e)}
            options={item.options
              .filter((x: IInputOption) => x.status)
              .map((opt: IInputOption) => ({
                label: opt.label,
                value: opt.value,
              }))}
          >
            {item.label}
          </ACheckBoxGroup>
        );
      case 'textarea':
        return (
          <ATextArea
            name={getKeyField(item.labelText)}
            value={hideButtonEdit ? formData[item.id] : ''}
            onChange={(e) => handlerFormData(item.id, e.target.value)}
            style={{ resize: 'none' }}
          />
        );
      default:
        return (
          <AInput
            name={getKeyField(item.labelText)}
            type={item.type}
            value={hideButtonEdit ? formData[item.id] : ''}
            placeholder={item.label}
            onChange={(e) => handlerFormData(item.id, e.target.value)}
          />
        );
    }
  };

  const renderButtons = (item: IInput, index: number) => {
    return (
      <>
        {!item.form_id && (
          <AButton
            danger
            type="primary"
            icon={<DeleteOutlined />}
            onClick={() => deleteInput(index)}
          />
        )}
        <AButton
          type="default"
          icon={<EditOutlined />}
          onClick={() => editInput(item)}
        />
      </>
    );
  };

  if (!inputs.length)
    return <ATitle level={5}>- Sem campos adicionados.</ATitle>;

  return (
    <Form style={{ margin: '6px 0px' }}>
      {inputs.map((item: IInput, index: number) => (
        <Row
          key={item.id}
          style={{
            display: 'flex',
            margin: '4px 0px',
            padding: '25px 5px',
            border: '1px solid #f0f0f0',
            borderRadius: 8,
          }}
        >
          <Col span={hideButtonEdit ? 24 : 21}>
            <Form.Item label={item.label} required={item.required}>
              {renderInput(item.type, item)}
            </Form.Item>
          </Col>
          {!hideButtonEdit && (
            <Col
              span={2}
              style={{ display: 'flex', flexDirection: 'row', margin: 10 }}
            >
              {renderButtons(item, index)}
            </Col>
          )}
        </Row>
      ))}
    </Form>
  );
};
